<template>
  <div class="loading-container">
    <p class="center">{{message}}</p>
    <div class="loading">
      <img src="@/assets/img/loading.gif">
    </div>
  </div>
</template>

<script>
export default {
  name: 'Loading',
  props: {
    message: String
  }
}
</script>

<style scoped>
  div.loading {
    margin: 0 auto;
    width: 100px;
    height: 100px;
  }
</style>
